import React, { useState } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { useDropzone } from "react-dropzone";
import { Modal, Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import DOMPurify from "dompurify";
import { useFetchData } from "../../hooks/useFetchData";
import Stepper from "react-stepper-horizontal";
import PdfUpload from "../PdfUpload";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import useAxios from "../../hooks/useAxios";
import { useQueryClient } from "@tanstack/react-query";

const CreatePayment = ({ show, onHide, accountId }) => {
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [payload, setPayload] = useState({
    accountId,
  });
  const [paymentId, setPaymentId] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const axiosInstance = useAxios()

  const collectionAccountUrl = "payments/collectionAccounts";
  const { data: collectionAccounts } = useFetchData(
    ["payment-collections"],
    collectionAccountUrl,
    true
  );
  const queryClient = useQueryClient();

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    const sanitizedValue = DOMPurify.sanitize(value);
    setPayload({
      ...payload,
      [name]: sanitizedValue,
    });
  };


  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const sanitizedPayload = {
      ...payload,
      collectionAccountId: DOMPurify.sanitize(payload.collectionAccountId),
      phoneNumber: DOMPurify.sanitize(payload.phoneNumber),
      referenceNumber: DOMPurify.sanitize(payload.referenceNumber),
      bankAccountNumber: DOMPurify.sanitize(payload.bankAccountNumber),
      amount: DOMPurify.sanitize(payload.amount),
      message: DOMPurify.sanitize(payload.message),
      paymentDate: selectedMonth.toISOString(),
    };
    const url = `${baseUrl}/payments/collections`;
    axiosInstance({
      url,
      method: "POST",
      headers:{
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data:sanitizedPayload,
    })
      .then((res) => {
        if (res?.data.id) {
          setPaymentId(res?.data.id);
          setActiveStep(1);
          onHide();
          setLoading(false);
        }
        setTimeout(() => {
          queryClient.invalidateQueries(["fetch-account"]);
        }, 3000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <Modal
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
      >
        <Modal.Header closeButton onClick={onHide}>
          <Modal.Title>
            <h5>
              {/* {activeStep === 0 ? "Create payment" : "Upload payment proof"} */}
              Create payment
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <Stepper
            steps={[
              { title: "Create payment" },
              { title: "Upload payment proof" },
            ]}
            activeStep={activeStep}
          /> */}
          {/* {activeStep === 0 && ( */}
            <Form onSubmit={onSubmit}>
              <label className='ml-2 mt-2'>Account Id</label>
              <input
                className='form-control'
                placeholder='Type amount'
                name='accountId'
                value={accountId}
                readOnly
              />
              <label className='ml-2 mt-2'>Collection Account</label>
              <select
                className='form-control mt-2'
                name='collectionAccountId'
                onChange={handleOnChange}
                required
              >
                <option value=''>select collection account</option>
                {collectionAccounts?.map((account) => (
                  <option key={account.id} value={account.id}>
                    {account.name}
                  </option>
                ))}
              </select>
              <label className='ml-2 mt-2'>Payment Date</label>
              <div style={{ width: "100%" }}>
                <DatePicker
                  selected={selectedMonth}
                  onChange={(date) => setSelectedMonth(date)}
                  dateFormat='dd/MM/yyyy'
                  showFullMonthYearPicker
                  showMonthDropdown
                  name='paymentDate'
                  className='custom-datepicker form-control'
                />
              </div>
              <label className='ml-2 mt-2'>Phone number</label>
              <input
                type='number'
                className='form-control'
                placeholder='Phone number'
                name='phoneNumber'
                onChange={handleOnChange}
                required
              />
              <label className='ml-2 mt-2'>Reference Number</label>
              <input
                type='text'
                className='form-control'
                placeholder='Refrence number'
                name='referenceNumber'
                onChange={handleOnChange}
                required
              />
              <label className='ml-2 mt-2'>Bank Account Number</label>
              <input
                type='number'
                className='form-control'
                placeholder='Account number'
                name='bankAccountNumber'
                onChange={handleOnChange}
                required
              />
              <label className='ml-2 mt-2'>Amount</label>
              <input
                type='number'
                className='form-control'
                placeholder='Type amount'
                name='amount'
                onChange={handleOnChange}
                required
              />
              <label className='ml-2 mt-2'>Message</label>
              <textarea
                placeholder='Enter  Message'
                className='form-control mt-2'
                name='message'
                onChange={handleOnChange}
                required
              />
              <div className='d-flex justify-content-center'>
                <Button className='custom-btn-color' type='submit' disabled={loading}>
                  {loading ? "Loading..." : "Submit"}
                </Button>
              </div>
            </Form>
          {/* // )} */}
        </Modal.Body>
        {/* {activeStep === 1 && paymentId && (
          <Modal.Body>
            <PdfUpload paymentId={paymentId} onHide={onHide} />
          </Modal.Body>
        )} */}
      </Modal>
    </div>
  );
};

export default CreatePayment;
